import {useState} from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import {useFirebaseProject, FirebaseContext} from "@meddbriefer/mdb-firebase"
import { AuthProvider, StaffRoute } from "@meddbriefer/mdb-auth";

import { environment } from "./environments/environment";

import { HeaderContext } from "./components/HeaderContext";

import "./styles/default-styles.scss";
import "./styles/home-styles.scss";
import "./styles/scenario-editor-styles.scss";
import "./styles/class-codes-styles.scss";
// import "./styles/problems-styles.scss";
import "./styles/tab-styles.scss"
import "./styles/scenario-type.scss"
import "./styles/checklist-styles.scss"
import "./styles/medications-styles.scss";

import UnauthedLayout from "./components/UnauthedLayout"

import Header from "./components/Header";


import HomePage             from "./components/HomePage";

import ScenarioTypeList     from "./components/ScenarioTypeEditor/ScenarioTypeList"
import NewScenarioType      from "./components/ScenarioTypeEditor/NewScenarioType";
import ScenarioType         from "./components/ScenarioTypeEditor/ScenarioType";

import ScenariosList        from "./components/ScenarioEditor/ScenariosList";
import NewScenario          from "./components/ScenarioEditor/NewScenario";
import EditScenario         from "./components/ScenarioEditor/EditScenario";
import CloneScenario        from "./components/ScenarioEditor/CloneScenario";
import PublishScenario      from "./components/ScenarioEditor/PublishScenario"

import ClassCodesList       from './components/ClassCodes/ClassCodesList';
import NewClassCode         from "./components/ClassCodes/NewClassCode"
import ClassCode            from './components/ClassCodes/ClassCode';


export default function App() {
	const {auth, db} = useFirebaseProject(environment.firebaseProject)
	const [title, setTitle] = useState("")

	return (
    <FirebaseContext.Provider
      value={{
        auth,
        db
      }}
    >
      <AuthProvider>
        <Router>
          <HeaderContext.Provider
            value={{
              title: title,
              setTitle: setTitle,
            }}
          >
            <Header />
            <Switch>
              <StaffRoute
                exact
                path="/scenario-types"
                authFlowLayout={UnauthedLayout}
                component={ScenarioTypeList}
              />
              <StaffRoute
                path="/scenario-type/:scenarioTypeID"
                authFlowLayout={UnauthedLayout}
                component={ScenarioType}
              />
              <StaffRoute
                exact
                path="/scenario-type"
                authFlowLayout={UnauthedLayout}
                component={NewScenarioType}
              />
              <StaffRoute
                exact
                path="/scenarios"
                authFlowLayout={UnauthedLayout}
                component={ScenariosList}
              />
              <StaffRoute
                exact
                path="/scenario/"
                authFlowLayout={UnauthedLayout}
                component={NewScenario}
              />
              <StaffRoute
                path="/scenario/:scenarioId/clone"
                authFlowLayout={UnauthedLayout}
                component={CloneScenario}
              />
              <StaffRoute
                path="/scenario/:scenarioId/publish"
                authFlowLayout={UnauthedLayout}
                component={PublishScenario}
              />
              <StaffRoute
                path="/scenario/:scenarioId"
                authFlowLayout={UnauthedLayout}
                component={EditScenario}
              />
              <StaffRoute
                exact
                path="/class-codes/"
                authFlowLayout={UnauthedLayout}
                component={ClassCodesList}
              />
              <StaffRoute
                exact
                path="/class-code/"
                authFlowLayout={UnauthedLayout}
                component={NewClassCode}
              />
              <StaffRoute
                path="/class-code/:classCode"
                authFlowLayout={UnauthedLayout}
                component={ClassCode}
              />
              {/* catchall route */}
              <Route component={HomePage} />
            </Switch>
          </HeaderContext.Provider>
        </Router>
      </AuthProvider>
    </FirebaseContext.Provider>
  )
}

